export default __webpack_public_path__ + "static/media/h-rl-b.f15f14f6.png";